const pt = {
  forbidden_page: {
    message: 'Desculpe, você não tem permissão para ver esta página.',
  },

  page_404: {
    message: '(404) Desculpe, esta página não existe.',
    click: 'Clique',
    here: 'aqui',
    to_return: 'para voltar à página inicial.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Entrando...',
  },

  dashboard_page: {
    welcome: 'Bem-vindo',
    intro: 'Solução completa para inspeção digital.',
    scan_project_code: 'Escanear código do projeto',
    new_version_available: 'Nova versão disponível!',
    websocket_status: 'Status do WebSocket',
    dij_version: 'Digital Inspection Jacket {version}',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Criar nova tarefa',
    back_to_product_list:
      'Depois de concluir aqui, volte para a lista de modelos de produto para que outros possam trabalhar neste modelo',
    back_to_work_order_list:
      'Depois de concluir aqui, volte para a lista de ordens de trabalho para que outros possam trabalhar neste pedido',
    drop_file_reference_image:
      'Solte o arquivo aqui ou clique para enviar a imagem de referência',
    reference_image: 'Imagem de referência',
    signed_off_by: 'Assinado por {name}',
    task_not_available_offline: 'Tarefa não disponível offline',
    need_help_chat: 'Precisa de ajuda? Clique aqui para conversar!',
    loading_user_roles: 'Carregando papéis de usuário...',
    loading_job_details: 'Carregando detalhes do trabalho...',
    checking_job_status: 'Verificando status do trabalho...',
    loading_job_tasks: 'Carregando tarefas do trabalho...',
    deleting_task: 'Excluindo tarefa...',
    duplicating_folder: 'Duplicando pasta...',
    select_folder_to_move: 'Selecione a pasta para mover.',
    delete_folder_confirmation_message:
      'Excluir uma pasta irá excluir todas as tarefas dentro dela.',
    delete_confirmation: 'Tem certeza de que deseja excluir?',
  },

  create_new_user_page: {
    create_new_user: 'Criar novo usuário',
    create_user: 'Criar usuário',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    gid: 'GID',
    email: 'E-mail',
    password: 'Senha',
    role: 'Função',
    all_fields_required: 'Por favor, preencha todos os campos obrigatórios.',
    user_failed: 'Falha na criação do usuário.',
    user_success: 'Usuário criado com sucesso.',
    password_validation:
      'Requisitos de senha: pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, nenhuma parte do seu nome de usuário.',
  },

  change_password_page: {
    change_password: 'Alterar senha',
    change_user_password: 'Alterar senha do usuário',
    password_change_success: 'Senha alterada com sucesso',
    secret_question_success: 'Pergunta secreta definida com sucesso',
    password_change_fail: 'Falha ao alterar a senha.',
    secret_question_fail: 'Falha ao definir pergunta secreta',
    email: 'E-mail',
    oldPassword: 'Senha antiga',
    password: 'Nova senha',
    confirmNewPassword: 'Confirmar nova senha',
    password_should_match: 'A nova senha e a confirmação devem corresponder.',
    password_validation:
      'Requisitos de senha: pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, nenhuma parte do seu e-mail.',
    passwordLowerCase: 'A senha deve conter pelo menos um caractere minúsculo.',
    passwordUpperCase: 'A senha deve conter pelo menos um caractere maiúsculo.',
    passwordNumber: 'A senha deve conter pelo menos um dígito.',
    passwordMinLength: 'A senha deve ter pelo menos 8 caracteres.',
    passwordNoUsernameParts:
      'A senha não pode conter nenhuma parte do nome de usuário.',
  },

  profile_page: {
    myProfile: 'Meu perfil',
    account: 'Conta',
    preferences: 'Preferências',
    profileUpdated: 'Perfil atualizado com sucesso',
    updatePreferences: 'Atualizar preferências',
    updateAccount: 'Atualizar conta',
    my_name: 'Meu nome',
    username: 'Nome de usuário',
    email: 'E-mail',
    location: 'Localização',
    phone_number: 'Telefone',
  },

  task_view: {
    cancel: 'Cancelar',
    back: 'Voltar',
    save: 'Salvar',
    delete: 'Excluir',
    deleteConfirmation:
      'Tem certeza de que deseja <b>excluir</b> a tarefa <b>{taskTitle}</b>?',
    deleteTask: 'Excluir tarefa',
    manageMte: 'Registro de instrumentação',
    repairAssessment: 'Avaliação de reparo',
    importAccuScan: 'Importar AccuScan',
    importLaserscan: 'Importar Laser Scan',
    signOff: 'Assinar',
    orderItem: 'Pedir item',
  },

  text_size: 'Tamanho do texto',
  selection: 'Seleção',
  alignedlength: 'Comprimento alinhado',
  linearlength: 'Comprimento linear',
  positive_tolerance: '+ Tolerância',
  negative_tolerance: '- Tolerância',

  product_template_list: 'Lista de modelos de produto',
  work_order_list: 'Lista de ordens de trabalho',
  update: 'Atualizar',
  order: 'Ordem',
  select_folder: 'Selecionar pasta',
  move: 'Mover',
  add_task: 'Adicionar tarefa',
  add_folder: 'Adicionar pasta',
  add_field: 'Adicionar campo',
  message_order_drag: 'Agora você pode ordenar suas tarefas, basta arrastá-las',
  move_folder: 'Mover para pasta',
  move_selected: 'Mover selecionados',
  select: 'Selecionar',
  delete_selected: 'Excluir selecionados',

  admin: 'Admin',
  editor: 'Editor',
  publisher: 'Publicador',
  inspector: 'Inspetor',
  report: 'Relatório',
  dashboard: 'Painel',
  profile: 'Perfil',
  language: 'Idioma',
  view_profile: 'Ver perfil',
  manage_fleet_data: 'Gerenciar dados da frota',
  report_issue: 'Reportar problema',
  request_content: 'Solicitar conteúdo',
  contact_us: 'Contato',
  forum: 'Fórum Viva Engage',
  training: 'Treinamento',
  log_out: 'Sair',

  choose_language: 'Escolha seu idioma preferido.',

  create_new_product: 'Criar novo produto',
  title: 'Título',
  product_line: 'Linha de produto',
  original_OEM: 'OEM original',
  frame_type: 'Tipo de estrutura',
  model: 'Modelo',
  part_number: 'Número da peça',
  document_number: 'Número do documento',
  revision: 'Revisão',
  cancel: 'Cancelar',
  submit: 'Enviar',
  delete: 'Excluir',
  save: 'Salvar',
  done: 'Concluído',
  new_product_success: 'Novo produto criado com sucesso.',
  new_product_fail_message:
    'Erro ao criar novo trabalho! Tente novamente.',

  // Tool names inside diagram
  'Selection Tool': 'Ferramenta de seleção',
  'Pan Viewport': 'Mover visualização',
  Diameter: 'Diâmetro',
  'Run-Out': 'Batimento',
  'Linear Length': 'Comprimento linear',
  'Visual Inspection': 'Inspeção visual',
  Text: 'Texto',
  'Generic Measurement': 'Medição genérica',
  Arrow: 'Seta',
  Line: 'Linha',
  'Replace Image': 'Substituir imagem',

  // Bubble names
  generic: 'Marcador genérico',
  generic_name: 'Nome genérico',
  runout: 'Batimento',
  length: 'Comprimento',
  diameter: 'Diâmetro',
  arrow: 'Seta',
  line: 'Linha',
  text: 'Texto',
  visualInspection: 'Inspeção visual',

  // Bubble properties
  label_numbers_only: 'Rótulo (somente números)',
  expected_value: 'Valor esperado',
  decimals: 'Decimais',
  units: 'Unidades',
  inch: 'polegada',
  mm: 'mm',
  tolerance_type: 'Tipo de tolerância',
  tolerance: 'Tolerância',
  multiple_positions: 'Múltiplas posições',
  edit_table: 'Editar tabela',
  orientation: 'Orientação',
  measurement_name: 'Nome da medição',
  visual_name: 'Nome visual',
  marker_description: 'Descrição',
  generic_marker_tolerance: 'Tolerância',
  direction: 'Direção',
  degrees: 'Graus',
  clock: 'Relógio',
  rotate_text: 'Girar texto',
  rubbed: 'Riscado',
  damaged: 'Danificado',
  pitted: 'Picado',
  eroded: 'Erodido',
  high: 'Alto',
  low: 'Baixo',
  medium: 'Médio',
  acceptable: 'Aceitável',
  all: 'Todos',
  position: 'Posição',
  tir: 'TIR',
  ok: 'OK',
  in: 'polegada',
  iso_name: 'ISO',
  iso_grade: 'Grau ISO',
  RAT: 'RAT',
  none: 'Nenhum',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Deseja salvar suas alterações?',
  discard: 'Descartar',
  stay: 'Permanecer',
  back: 'Voltar',
  dismiss: 'Dispensar',

  import_drawing: 'Importar desenho',
  work_order_list: 'Lista de ordens de trabalho',

  edit_name: 'Editar nome',
  reopen: 'Reabrir',

  //Instruction actions
  create_new_item: 'Criar novo item',
  options: 'Opções',
  add_iso: 'Adicionar ISO',
  add_calculation: 'Adicionar cálculo',
  recover: 'Recuperar',
  loading: 'Carregando...',
  clear_filters: 'Limpar filtros',
  job_downloaded_locally: 'Trabalho baixado localmente',
  job_has_incomplete_data: 'Trabalho com dados incompletos',
  job_includes_repair_assessment: 'Este trabalho inclui avaliações de reparo',
  text: 'Texto',
  sap_reference: 'Referência SAP',
  filter: 'Filtro',
  current_owner: 'Proprietário atual',
  current_owner_date: 'Proprietário atual / Data',

  template_list: {
    retrieving_listings: 'Recuperando listagens com base na sua pesquisa...',
    fetched_pages_found:
      '{batchCount} páginas recuperadas até agora. {size} listagens encontradas...',
    found_listings: 'Encontradas {length} listagens que atendem aos critérios.',
    failed_to_fetch_listings: 'Falha ao recuperar listagens',
  },

  table: 'Tabela',
  import_csv: 'Importar CSV',

  action_requested: 'Ação solicitada',
  picture_taken_is_mandatory: 'A foto é obrigatória.',
  picture_uploaded_successfully: '{image} enviado com sucesso',
  picture_required: 'Imagem obrigatória.',
  your_question: 'Sua pergunta',
  question: 'Pergunta',
  options: 'Opção',
  add_an_option: 'Adicionar uma opção',
  multiple_choice: 'Múltipla escolha',
  text_or_number: 'Texto ou número',

  number_of_rows: 'Número de linhas',
  number_of_columns: 'Número de colunas',
  edit_rows: 'Editar linhas',
  edit_columns: 'Editar colunas',
  only_numbers_and_alphabets:
    'Apenas números e letras com até 16 caracteres são permitidos em uma célula',
  table_headings_not_empty: 'Os cabeçalhos da tabela não podem estar vazios',
  upload_diagram: 'Enviar diagrama',

  yes: 'Sim',
  no: 'Não',

  product_template_list: 'Lista de modelos de produto',
  product_line: 'Linha de produto',
  work_order_list: 'Lista de ordens de trabalho',
  favorite_list: 'Lista de favoritos',
  search: 'Pesquisar',
  add_product: 'Adicionar produto',
  title: 'Título',
  original_OEM: 'OEM original',
  frame_type: 'Tipo de estrutura',
  model: 'Modelo',
  part_number: 'Número da peça',
  location: 'Localização',
  document_number: 'Número do documento',
  revision: 'Revisão',
  created_by: 'Criado por',
  date: 'Data',
  edit: 'Editar',
  delete: 'Excluir',
  duplicate: 'Duplicar',
  copyfrom: 'Copiar de',
  nothing_here: 'Nada aqui',

  project_number: 'Número do projeto',
  customer: 'Cliente',
  work_order_number: 'Número da ordem de trabalho',
  serial_number: 'Número de série',
  sales_force_number: 'Número do Sales Force',
  add_order: 'Adicionar pedido',
  edit_order: 'Editar pedido',
  original_oem_number: 'Número OEM original',
  freefinding: 'Achado livre',

  part_level: 'Nível da peça',

  new_product_success_message: 'Novo produto criado com sucesso!',
  new_product_fail_message:
    'Erro ao criar novo trabalho! Tente novamente.',

  task_count: 'Quantidade de tarefas',
  selection_from_list: 'Se desejar, selecione a partir da lista',
  select_tasks: 'Selecionar tarefas',
  select_products: 'Selecionar produtos (opcional)',

  select_all: 'Selecionar tudo',
  deselect_all: 'Desmarcar tudo',
  select_site: 'Selecionar site',
  selected_products: 'Produtos selecionados',
  review: 'Revisar',
  sites: 'Sites secundários',
  products: 'Produtos',
  tasks: 'Tarefas',
  next: 'Próximo',

  sign_off: 'Assinar',
  sign_off_questions_completed: '{completed}/{total} concluído(s).',
  sign_off_diagram_completed: 'Diagrama {percent}% concluído.',
  sign_off_comments_label: 'Por favor, insira seus comentários aqui...',
  number_of_measurement_points: 'Número de pontos de medição',
  stage: 'Etapa',
  number_of_stages: 'Número de etapas',
  add_job_with_table_message:
    'Desculpe, você não pode adicionar novos trabalhos porque selecionou um trabalho com uma tabela de tarefas.',
  configure_table_order: 'Configurar tabela',
  version: 'Versão',
  task_completed_message:
    'Tarefa já assinada! Reabra para alterações adicionais!',

  create_task: {
    create_new_task: 'Criar nova tarefa',
    diagram: 'Diagrama',
    instruction: 'Instrução',
    worksheet: 'Planilha',
    task_name: 'Nome da tarefa',
    cancel: 'Cancelar',
    done: 'Concluído',
    select_software_tool: 'Selecionar ferramenta de software',
  },

  create_folder: {
    create_new_folder: 'Criar nova pasta',
    folder_name: 'Nome da pasta',
    select_software_tool: 'Selecionar ferramenta de software',
    configure_new_part: 'Configurar nova peça',
    draw_no_b_plan: 'Nº desenho (B-Plan)',
    draw_no: 'Nº desenho',
    draw_no_turbinenlaufer: 'Nº desenho (Turbinenlaufer)',
    draw_no_nutenplan: 'Nº desenho (Nutenplan)',
    draw_no_welle_vorne: 'Nº desenho (Wellenende vorne)',
    draw_no_welle_hinten: 'Nº desenho (Wellenende hinten)',
    draw_no_einstromteil: 'Nº desenho (Einstromteil)',
    draw_no_abstromteil: 'Nº desenho (Abstromteil)',
    rotor_id: 'ID do rotor',
    parts_list: 'Lista de peças',
    hallmark: 'Marca de verificação',
    delete_title: 'EXCLUIR',
    delete_field_confirmation: 'Excluir campo {label}?',
    name_prompt: 'Nome',
    field_already_exists: 'Campo já existe.',
    failed_create_task: 'Falha ao criar nova tarefa',
  },

  emfProductList: {
    workOrderList: 'Lista de ordens de trabalho',
    search: 'Pesquisar',
    addOrder: 'Adicionar pedido',
    next: 'Próximo',
    previous: 'Anterior',

    productLine: 'Linha de produto',
    title: 'Título',
    originalOEM: 'OEM original',
    frameType: 'Tipo de estrutura',
    model: 'Modelo',
    partNumber: 'Número da peça',
    customer: 'Cliente',
    projectNumber: 'Nº do projeto',
    serialNumber: 'Nº de série',
    workOrder: 'Ordem de trabalho',
    salesForce: 'Nº da oportunidade Sales Force',
    createdBy: 'Criado por',
  },

  loginSession: {
    admin: 'Administrador',
    editor: 'Editor',
    publisher: 'Publicador',
    inspector: 'Inspetor',
    report: 'Relatório',
    dashboard: 'Painel',
    language: 'Idioma',
    profile: 'Perfil',
    viewProfile: 'Ver perfil',
    manageFleetData: 'Gerenciar dados da frota',
    reportIssue: 'Reportar problema',
    requestContent: 'Solicitar conteúdo',
    contactUs: 'Contato',
    training: 'Treinamento',
    logOut: 'Sair',
  },

  404: 'Não encontrado',

  table_template: {
    create_table: 'Criar tabela',
    new_column: 'Adicionar nova coluna',
    new_row: 'Adicionar nova linha',
    delete_column: 'Excluir coluna selecionada',
    delete_row: 'Excluir linha selecionada',
  },

  calculation: {
    sum: 'Soma',
    sub: 'Subtrair',
    mult: 'Multiplicar',
  },

  duplicate_work_order_number: 'O número da ordem de trabalho já está em uso',
  view_qr_code: 'Ver QR Code',
  download_qr_code: 'Baixar QR Code',
  download_traveler: 'Baixar Traveler',
  include_repair_assessment: 'Incluir avaliação de reparo',
  repair_assessment: 'Avaliação de reparo',
  import: 'Importar',
  import_editor_template: 'Modelos existentes',
  import_add_excel_file: 'Adicionar a partir de arquivo Excel',
  download_excel_file: 'Baixar arquivo de modelo',
  export_task: 'Exportar tarefa',
  saved: 'Salvo',
  not_saved: 'Não salvo',
  level: 'Nível',
  assembly: 'Montagem',
  item_number: 'Número do item',
  part_name: 'Nome da peça',
  part_number: 'Número da peça',
  quantity: 'Quantidade',
  serialNumber: 'Número de série',
  actions: 'Ações',
  no_records: 'Nenhum registro',
  repair_assessment_empty:
    'A avaliação de reparo está vazia. Comece importando dados ou adicione manualmente',
  repair_assessment_empty_readonly: 'A avaliação de reparo está vazia.',
  close: 'Fechar',
  close_notification: 'Fechar notificação',
  import_add: 'Importar',
  change_log: 'Registro de alterações',

  add_row: 'Adicionar linha',
  remove_row: 'Remover linha',

  repair_assessment_excel_import_failed:
    'Falha ao importar a avaliação de reparo do arquivo Excel',

  reuse: 'Reutilizar',
  repair: 'Reparar',
  replace: 'Substituir',
  missing: 'Faltando',
  client_reject: 'Rejeição do cliente',
  received: 'Recebido',
  quality_control_override: 'CQ',
  reviewed: 'Revisão Eng.',
  comments: 'Comentários',

  findings: 'Achados',
  recommendations: 'Recomendações',

  visual: 'Visual',
  dim: 'Dim',
  ndt: 'NDT',

  summary: 'Resumo',
  repair_scope: 'Escopo de reparo',
  estimated_labor: 'Horas est.',

  not_repair_engineer: 'Apenas engenheiros podem revisar',

  pre_assembly_audit: 'Auditoria pré-montagem',
  donwload_rat: 'Exportar componentes',
  repair_assessment_search_empty: 'Nenhum item disponível.',

  delete_all: 'Excluir tudo',
  delete_all_message:
    'Isso excluirá todas as informações relacionadas à avaliação de reparo.',
  delete_major_message:
    'Isso excluirá as informações de componentes principais relacionadas à avaliação de reparo.',
  delete_minor_message:
    'Isso excluirá as informações de componentes secundários relacionadas à avaliação de reparo.',

  repair_assessment_row_locked: 'Esta linha está bloqueada por {user}',

  feature_disabled: 'Este recurso está desativado em sua localização',

  locations: 'Localizações',

  recycle_bin: 'Lixeira',
  recycle_bin_empty: 'A lixeira está vazia',

  task_name: 'Nome',
  task_type: 'Tipo',
  deleted_by: 'Excluído por',
  deleted_at: 'Excluído em',

  executing_site: 'Site executor',

  na: 'N/D',

  owner: 'Proprietário',

  mtetype_create_title: 'Criar tipo de MTE',
  mtetype_update_title: 'Atualizar tipo de MTE',

  create: 'Criar',

  name: 'Nome',
  needs_master: 'Precisa de master',
  is_master: 'É master',

  mte_type_delete_question: 'Tem certeza de que deseja excluir este tipo de MTE?',
  mte_type_delete_success: 'Tipo de MTE excluído com sucesso',
  mte_type_delete_fail: 'Falha ao excluir o tipo de MTE',

  mte_management: 'Registro de instrumentação',
  add_using_camera: 'Adicionar usando câmera',
  close_camera: 'Fechar câmera',
  add_manual_entry: 'Adicionar entrada manual',

  id: 'ID',
  type: 'Tipo',
  due_date: 'Data de vencimento',
  master: 'Master',
  created_at: 'Criado em',

  masters: 'Masters',
  non_masters: 'Outros',

  mandatory_error_message: '{field} é obrigatório',
  mandatory_date_must_not_be_in_past_error_message:
    '{field} é obrigatório e não deve estar no passado',
  unique_error_message: '{field} deve ser único',

  task_locked_by_user: 'A tarefa está bloqueada pelo usuário {user} até {date}',

  clear: 'Limpar',
  surrogate: 'Substituto',
  stop_surrogating: 'Parar substituição',

  create_new_site_page: {
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    create_new_site: 'Criar novo site',
    all_fields_required: 'Por favor, preencha todos os campos obrigatórios.',
    site_failed: 'Falha ao criar o site.',
    site_success: 'Site criado com sucesso.',
  },

  edit_site_page: {
    edit_site: 'Editar site',
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    rat: 'Modelo de avaliação de reparo',
    mte_m: 'Registro de instrumentação',
    delete: 'Excluir',
    update: 'Atualizar',
    successMessage: 'Site atualizado com sucesso.',
    failedMessage: 'Falha ao atualizar o site.',
    delete_confirm: 'Tem certeza de que deseja excluir este site?',
    deletesite: 'Site excluído com sucesso.',
    deletefail: 'Falha ao excluir o site.',
  },
  site_list: {
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    DateModified: 'Data de modificação',
  },
  announcement_banner: {
    title: 'Banner de anúncio',
    description: 'Configure o banner de anúncio.',
    status: 'Status',
    message: 'Mensagem',
    start_date: 'Data de início',
    end_date: 'Data de término',
    clear_action: 'Limpar',
    preview_action: 'Pré-visualizar',
    save_action: 'Salvar',
    enabled_status: 'Ativado',
    disabled_status: 'Desativado',
    clear_question:
      'Isso desativará o banner de notificação para todos os usuários. Continuar?',
    end_date_error: 'A data de término deve estar no futuro',
  },
  edit_user_profile: {
    title: 'Perfil do usuário',
    user_owned_template_count: 'Este usuário é dono de {count} modelos',
    user_owned_job_count: 'Este usuário é dono de {count} trabalhos',
    reassign_jobs: 'Reatribuir trabalhos',
    reassign_templates: 'Reatribuir modelos',
    reassign_jobs_cancel: 'Cancelar reatribuição',
    pending_approval_message:
      'Este usuário está aguardando aprovação. Verifique as informações e aprove o perfil para que o usuário possa usar o DIJ',
    rejected_message:
      'Este usuário foi rejeitado e não pode acessar o DIJ. O usuário ainda pode ser aprovado se necessário.',
    success_message: 'Usuário atualizado com sucesso',
    full_name: 'Nome completo',
    email: 'E-mail',
    primary_location: 'Localização principal',
    secondary_locations: 'Localizações secundárias',
    phone_number: 'Telefone',
    role: 'Função',
    power_admin_role: 'Power Admin',
    placeholder_role: 'Função',
    ownership: 'Propriedade',
    additional_permissions: 'Permissões adicionais',
    enginner_review_permission: 'Revisão de engenharia',
    delete_button: 'Excluir',
    update_button: 'Atualizar',
    approve_button: 'Aprovar',
    reject_button: 'Rejeitar',
    cancel_button: 'Cancelar',
    approve_question:
      'Você está aprovando o usuário {name} com função "{role}" e localizações "{locations}". Continuar?',
    reject_question:
      'Você está rejeitando {name}. O usuário não poderá usar o DIJ. Continuar?',
    approve_success_message: 'Usuário aprovado com sucesso',
    reject_success_message: 'Usuário rejeitado com sucesso',
    update_success_message: 'Informações do usuário atualizadas com sucesso',
    job_reassignment_success_message:
      'Os modelos deste usuário foram reatribuídos com sucesso',
  },
  new_user_welcome_page: {
    welcome_configurator_message:
      'Bem-vindo ao DIJ. Selecione os sites relevantes ao seu trabalho',
    pending_approval_part1_message:
      'Sua solicitação de acesso está aguardando aprovação.',
    pending_approval_part2_message: 'Volte mais tarde para acesso.',
    submit: 'Enviar',
  },
  user_list: {
    name: 'Nome completo',
    email: 'E-mail',
    location: 'Localização',
    role: 'Função',
    last_login: 'Último login',
  },
  users: {
    approved: 'Aprovado',
    approved_description:
      'Lista de usuários aprovados. Esses usuários têm acesso total ao DIJ.',
    pending_approval: 'Aprovação pendente',
    pending_approval_description:
      'Lista de usuários a serem aprovados. Esses usuários não podem acessar o DIJ até que seu perfil seja aprovado.',
    todays_logins: 'Logins de hoje',
    todays_logins_description:
      'Lista de usuários que fizeram login hoje. Reinicia diariamente à meia-noite.',
    rejected: 'Rejeitado',
    rejected_description:
      'Lista de usuários que foram rejeitados durante o processo de aprovação. Esses usuários não sabem que foram rejeitados.',
  },
  user_picker: {
    label: 'Selecionar usuário',
    placeholder: 'Digite e selecione usuários disponíveis',
    no_match_found: 'Nenhuma correspondência encontrada',
    email: 'E-mail',
    role: 'Função',
  },

  sign_off_instruction_not_completed:
    'Algumas instruções na tarefa não foram totalmente concluídas. Tem certeza de que deseja assinar a tarefa? Isso bloqueará futuras alterações.',
  sign_off_diagram_not_completed:
    'Alguns pontos de inspeção na tarefa não foram concluídos. Tem certeza de que deseja assinar a tarefa? Isso bloqueará futuras alterações.',

  chat_box: {
    generated_content_warning:
      'O conteúdo é gerado automaticamente por IA e pode conter imprecisões',
    type_message_placeholder: 'Digite sua mensagem...',
    send: 'Enviar',
    regenerate: 'Gerar novamente',
    please_wait: 'Aguarde...',
    clear_local_history: 'Limpar histórico local',
    click_to_copy: 'Clique para copiar',
  },
  report_template: {
    project_title: 'Título do projeto',
    enter_project_number: 'Digite o número do projeto',
    customer: 'Cliente',
    enter_customer_information: 'Digite as informações do cliente',
    customer_tag: 'Tag do cliente',
    enter_customer_tag: 'Digite a tag do cliente',
    customer_po_no: 'Nº do pedido do cliente',
    unit_serial: 'Nº de série da unidade',
    enter_serial_info: 'Digite o número de série',
    unit_model: 'Modelo da unidade',
    project_number: 'Número do projeto',
    sales_force_opportunity_number: 'Nº da oportunidade Sales Force',
    enter_sales_force_opportunity_number:
      'Digite o nº da oportunidade Sales Force',
    process: 'Processo',
    enter_process: 'Digite o processo',
    original_order_no: 'Nº do pedido original',
    enter_original_order_no: 'Digite o nº do pedido original',
    previous_orders: 'Pedidos anteriores',
    enter_previous_orders: 'Digite pedidos anteriores',
    contact_person_name: 'Nome do contato',
    enter_contact_person_name: 'Digite o nome do contato',
    contact_person_department: 'Departamento do contato',
    executive_summary: 'Resumo executivo',
    generate_executive_summary: 'Gerar resumo executivo',
    repair_select: 'Seleção de reparo',
    sample_text: 'Texto de exemplo:',
    sample_text_content:
      'A Siemens forneceu serviços técnicos em nome da Duke Energy Carolinas LLC para inspecionar e recomendar reparos para um conjunto de rotor EMM32A3N. O conjunto do rotor foi enviado para a unidade de reparo da Siemens em Charlotte, Carolina do Norte, para inspeção de entrada.',
    revision_description: 'Descrição da revisão',
    enter_revision_description: 'Digite a descrição da revisão',
    csm: 'CSM',
    enter_csm: 'Digite o CSM',
    repair_engineer: 'Engenheiro de reparo',
    enter_repair_engineer: 'Digite o engenheiro de reparo',
    major_components: 'Componentes principais',
    minor_components: 'Componentes secundários',
    work_performed_fact_finding:
      'Trabalho realizado para inspeção de apuração de fatos',
    work_performed_repair: 'Trabalho realizado para reparo',
    repairs_not_completed_recommendations_upgrades:
      'Reparos não concluídos, recomendações e upgrades',
    appendix: 'Apêndice',
  },

  report_header: {
    internal_report: 'Relatório interno',
    customer_report: 'Relatório do cliente',
    exclude_items: 'Excluir itens',
    documents: 'Documentos',
    revisions: 'Revisões',
    description: 'Descrição: {description}',
    download: 'Baixar',
    header: 'Cabeçalho',
    deviation_report: 'Relatório de desvio',
    repair_assessment: 'Avaliação de reparo',
    work_performed: 'Trabalho realizado',
    deleting_report_revision: 'Excluindo revisão do relatório',
    delete_revision_confirmation:
      'Tem certeza de que deseja <b>excluir</b> a revisão: {fileName}, descrição: {description}? Esta ação não pode ser desfeita.',
    delete_revision: 'Excluir revisão',
  },

  report_tasks: {
    table: 'TABELA',
    form_inspection: 'INSPEÇÃO DE FORMULÁRIO',
    document_number: 'Número do documento:',
    revision: 'Revisão:',
    no_records: 'Sem registros',
    item: 'ITEM',
    answer: 'RESPOSTA',
    attachments_uc: 'ANEXO(S)',
    inspector: 'INSPETOR',
    date: 'DATA',
    inspection_diagram: 'DIAGRAMA DE INSPEÇÃO',
    length_measurements: 'MEDIÇÕES DE COMPRIMENTO',
    diameter_measurements: 'MEDIÇÕES DE DIÂMETRO',
    visual_inspection: 'INSPEÇÃO VISUAL',
    generic_measurements: 'MEDIÇÕES GENÉRICAS',
    label_uc: 'Rótulo',
    part_name_uc: 'Nome da peça',
    description_uc: 'Descrição',
    question_label: 'Pergunta:',
    name_label: 'Nome:',
    description_label: 'Descrição:',
    expected_value_uc: 'Valor esperado',
    tolerance1: 'Tolerância1',
    tolerance2: 'Tolerância2',
    unit: 'Unidade',
    inspector_title: 'Inspetor',
    date_title: 'Data',
    condition: 'Condição',
    severity: 'Severidade',
    measurement_name_uc: 'Nome da medição',
    runout_measurements: 'MEDIÇÕES DE BATIMENTO',
    tir: 'TIR',
    tolerance: 'Tolerância',
    task_prefix: 'Tarefa:',
    show_oot_colors: 'Mostrar cores fora da tolerância',
    free_finding: 'ACHADO LIVRE',
    attachments_plain: 'ANEXOS',
    pictures: 'fotos',
    excluded: 'excluídos',
  },

  deviation_report: {
    unit_serial: 'Nº de série da unidade:',
    review_only: 'Somente revisão',
    action_required: 'Ação necessária',
    assembly_bom: 'BOM da montagem',
    assembly_ref: 'REF da montagem',
    item_number: 'Item nº',
    original_pn: 'PN original',
    actions: 'Ações',
  },

  external_data: {
    title: 'DADOS EXTERNOS',
    upload_failed: 'Falha no envio do arquivo',
    item_uc: 'ITEM',
    file_name: 'Nome do arquivo',
    print_to_report: 'Imprimir no relatório',
    file_type_error: 'Este tipo de arquivo não pode ser impresso no relatório',
    delete: 'Excluir',
  },

  findings: {
    title: 'ACHADOS',
    by_inspector: 'Pelo inspetor',
    by_reporter: 'Pelo relator',
    placeholder: 'Por favor, insira seus achados aqui...',
  },
};

export default pt;
